import { Routes } from '@angular/router';

import { authGuard } from './core/auth/auth.guard';
import { sectionAccessGuard } from './pages/application-form/section-access.guard';
import { submissionWindowGuard } from './pages/application-form/submission-window.guard';

export const routes: Routes = [
	{
		path: '',
		pathMatch: 'full',
		loadComponent: () => import('./pages/landing/landing.component').then((m) => m.LandingComponent),
	},
	{
		path: 'auth/callback',
		loadComponent: () => import('./pages/auth-callback/auth-callback.component').then((m) => m.AuthCallbackComponent),
	},
	{
		// Recovery for an account stuck in Cognito's UNCONFIRMED state — reached from
		// the link in the verification email, or typed in from OARM support guidance.
		//
		// Deliberately NOT behind authGuard, and this is not an oversight: the whole
		// point is that the applicant CANNOT authenticate yet. A guard here would send
		// them to the Hosted UI, which is exactly the dead end they are escaping.
		//
		// Also load-bearing: the '**' route below silently redirects unmatched paths to
		// the landing page, so if this entry is ever removed the emailed link fails
		// with no error anywhere. `verify.component.spec.ts` pins it.
		path: 'verify',
		loadComponent: () => import('./pages/verify/verify.component').then((m) => m.VerifyComponent),
	},
	{
		path: 'dashboard',
		canMatch: [authGuard],
		loadComponent: () => import('./pages/dashboard/dashboard.component').then((m) => m.DashboardComponent),
	},
	{
		path: 'application/view/:id',
		// Read-only view of the applicant's own application. Deliberately a sibling
		// of the form (not a child), so it doesn't inherit the section shell/nav or
		// the section-access gating.
		canMatch: [authGuard],
		loadComponent: () => import('./pages/application-view/application-view.component').then((m) => m.ApplicationViewComponent),
	},
	{
		path: 'application',
		// Anonymous visitors never reach the form: canMatch runs before
		// canActivateChild, so the store load below is skipped entirely.
		canMatch: [authGuard],
		// Order matters. The window guard runs first, so an applicant who cannot save
		// is turned away before the section-ordering guard walks them to a resume
		// point inside a form they may not use. Both hydrate the store; the load is
		// idempotent, so the second call costs nothing.
		canActivateChild: [submissionWindowGuard, sectionAccessGuard],
		loadComponent: () => import('./pages/application-form/application-form.component').then((m) => m.ApplicationFormComponent),
		loadChildren: () => import('./pages/application-form/application-form.routes').then((m) => m.APPLICATION_FORM_ROUTES),
	},
	{ path: '**', redirectTo: '' },
];
